module.exports = __webpack_public_path__ + "img/icon-instagram.e0814599.svg";